import CURPError from './CURPError';
class UpdateCURPError extends CURPError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('UpdateCURPError', ...args);
    }
}
export default UpdateCURPError;
